import { createContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import {
  editDiscountCouponItemService,
  createDiscountCouponItemService,
  deleteDiscountCouponItemService,
  getDiscountCouponItemsService,
  getDiscountCouponService,
  getServicesService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { convertDate } from "../../../utils";

export const discountCouponAdminContext = createContext({
  discountCouponItems: [],
  setDiscountCouponItems: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  discountCoupon: {},
  setDiscountCoupon: () => {},
  services: [],
  setServices: () => {},
  managedCities: [],
  setManagedCities: () => {},
  selectedCities: [],
  setSelectedCities: () => {},
  search: "",
  setSearch: () => {},
  id: "",
  setId: () => {},
  title: "",
  setTitle: () => {},
  title_output: "",
  setTitle_output: () => {},
  ref_num: "",
  setRef_num: () => {},
  single_user: null,
  setSingle_user: () => {},
  amount: "",
  setAmount: () => {},
  percent: "",
  setPercent: () => {},
  max_discount_amount: "",
  setMax_discount_amount: () => {},
  min_invoice_amount: "",
  setMin_invoice_amount: () => {},
  expiration_date: "",
  setExpiration_date: () => {},
  is_active: null,
  setIs_active: () => {},
  description: "",
  setDescription: () => {},
  service: "",
  setService: () => {},
  usage_total: "",
  setUsage_total: () => {},
  usage_per_client: "",
  setUsage_per_client: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetServices: () => {},
  handleGetDiscountCouponItemList: () => {},
  handleGetDiscountCouponItem: () => {},
  handleCreateDiscountCouponItem: () => {},
  handleEditDiscountCouponItem: () => {},
  handleDeleteDiscountCouponItem: () => {},
});

const DiscountCouponAdminContext = ({ children }) => {
  const dispatch = useDispatch();
  const appConfigs = useSelector((state) => state.appConfigs);

  const [discountCouponItems, setDiscountCouponItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [discountCoupon, setDiscountCoupon] = useState({});
  const [services, setServices] = useState([]);
  
  // مدیریت شهرها مشابه الگوی OrderAdminContext
  const [managedCities, setManagedCities] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);

  useEffect(() => {
    const mine = appConfigs?.managed_cities;
    if (mine) {
      const formattedCities = mine.map(city => ({
        value: city.id,
        label: city.name
      }));
      setManagedCities(formattedCities);
    }
  }, [appConfigs]);

  const [search, setSearch] = useState("");
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [title_output, setTitle_output] = useState("");
  const [ref_num, setRef_num] = useState("");
  const [single_user, setSingle_user] = useState(false);
  const [amount, setAmount] = useState("");
  const [percent, setPercent] = useState("");
  const [max_discount_amount, setMax_discount_amount] = useState("");
  const [min_invoice_amount, setMin_invoice_amount] = useState("");
  const [expiration_date, setExpiration_date] = useState("");
  const [is_active, setIs_active] = useState(false);
  const [description, setDescription] = useState("");
  const [service, setService] = useState([]);
  const [usage_total, setUsage_total] = useState("");
  const [usage_per_client, setUsage_per_client] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);

  const handleResetState = () => {
    setId("");
    setTitle("");
    setRef_num("");
    setTitle_output("");
    setSingle_user(false);
    setAmount("");
    setPercent("");
    setMax_discount_amount("");
    setMin_invoice_amount("");
    setExpiration_date("");
    setIs_active(false);
    setDescription("");
    setService([]);
    setSelectedCities([]);
    setUsage_total("");
    setUsage_per_client("");
  };

  // Create DiscountCoupon Modal Operations
  const handleShowModal = (catValue) => {
    setIsShowModal(true);
    if (catValue) {
      setId(catValue.id);
      setTitle(catValue.title);
      setRef_num(catValue.ref_num);
      setTitle_output(catValue.title_output);
      setSingle_user(catValue.single_user);
      setAmount(catValue.amount);
      setPercent(catValue.percent);
      setMax_discount_amount(catValue.max_discount_amount);
      setMin_invoice_amount(catValue.min_invoice_amount);
      setExpiration_date(catValue.expiration_date);
      setIs_active(catValue.is_active);
      setDescription(catValue.description);
      setService(
        catValue.title?.split(",")?.map((_t) => ({
          label: _t,
          value: services?.find((_s) => _s?.label === _t)?.value,
        }))
      );
      // بارگذاری شهرهای مرتبط با کوپن
      if (catValue.city) {
        setSelectedCities(
          catValue.city.map((_c) => ({
            value: _c.id,
            label: _c.name,
          }))
        );
      } else {
        setSelectedCities([]);
      }
      setUsage_total(catValue.usage_total);
      setUsage_per_client(catValue.usage_per_client);
    }
  };

  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setDiscountCoupon(value);
  };

  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setDiscountCoupon({});
  };

  const handleGetServices = async (event) => {
    event?.preventDefault();
    const objData = { offset: 0, limit: 300, search: "" };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getServicesService(objData);
      if (status === 200) {
        setServices(
          data?.list?.map((_value) => ({
            value: _value?.id,
            label: _value?.name,
          }))
        );
      }
    } catch ({ response }) {
      if (response?.status) toastErrorMessage();
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  const handleGetDiscountCouponItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      limit: 100,
      offset: ((isSearch ? 1 : pageNumber) - 1) * 100,
      search,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getDiscountCouponItemsService(objData);
      if (status === 200) {
        setDiscountCouponItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) toastErrorMessage();
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  const handleGetDiscountCouponItem = async (id, isEdit) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getDiscountCouponService(id);
      if (status === 200) {
        if (isEdit) {
          handleShowModal(data);
        } else {
          handleShowDetailsModal(data);
        }
      }
    } catch ({ response }) {
      if (response?.status) toastErrorMessage(response?.data?.message);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  const handleCreateDiscountCouponItem = async (event) => {
    event?.preventDefault();

    const selectedCityIds = selectedCities ? selectedCities.map((c) => c.value) : [];

    const objData = {
      title: handleGetNameOfServicesWithId(),
      title_output,
      ref_num,
      single_user,
      amount,
      percent: Number(percent),
      max_discount_amount: Number(max_discount_amount),
      min_invoice_amount: Number(min_invoice_amount),
      expiration_date: convertDate(expiration_date, "YYYY-M-DD HH:mm:ss"),
      is_active,
      description,
      usage_total: Number(usage_total),
      usage_per_client: Number(usage_per_client),
      added_cities: selectedCityIds, // ارسال شهرها مطابق با متد _update_cities بک‌اند
    };

    if (!title_output) return toastErrorMessage("عنوان الزامی میباشد");
    if (!ref_num) return toastErrorMessage("کد تخفیف الزامی میباشد");
    if (!amount && !percent) return toastErrorMessage("مقدار یا درصد الزامی میباشد");
    if (!max_discount_amount) return toastErrorMessage("حداکثر مبلغ تخفیف الزامی میباشد");
    if (!min_invoice_amount) return toastErrorMessage("حداقل مبلغ فاکتور الزامی میباشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createDiscountCouponItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetDiscountCouponItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) toastErrorMessage();
      dispatch(setLoadingFalseAction());
    }
  };

  const handleEditDiscountCouponItem = async (event) => {
    event?.preventDefault();

    const selectedCityIds = selectedCities ? selectedCities.map((c) => c.value) : [];

    const objData = {
      id,
      title: handleGetNameOfServicesWithId(),
      title_output,
      ref_num,
      single_user,
      amount,
      percent: Number(percent),
      max_discount_amount: Number(max_discount_amount),
      min_invoice_amount: Number(min_invoice_amount),
      expiration_date: convertDate(expiration_date, "YYYY-M-DD HH:mm:ss"),
      is_active,
      description,
      usage_total: Number(usage_total),
      usage_per_client: Number(usage_per_client),
      added_cities: selectedCityIds,
    };

    if (!title_output) return toastErrorMessage("عنوان الزامی میباشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editDiscountCouponItemService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ویرایش شد");
        handleGetDiscountCouponItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) toastErrorMessage();
      dispatch(setLoadingFalseAction());
    }
  };

  const handleDeleteDiscountCouponItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteDiscountCouponItemService(id);
      if (status === 204) {
        toastSuccessMessage(`آیتم ${id} با موفقیت حذف شد`);
        handleGetDiscountCouponItemList();
      }
    } catch ({ response }) {
      if (response?.status) toastErrorMessage();
      dispatch(setLoadingFalseAction());
    }
  };

  const handleGetNameOfServicesWithId = () => {
    if (isEmpty(service)) return null;
    if (service === "all") return "all";
    const titles = service?.map((_value) => _value.label);
    return titles.toString();
  };

  return (
    <discountCouponAdminContext.Provider
      value={{
        discountCouponItems,
        setDiscountCouponItems,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        discountCoupon,
        setDiscountCoupon,
        services,
        setServices,
        managedCities,
        setManagedCities,
        selectedCities,
        setSelectedCities,
        search,
        setSearch,
        id,
        setId,
        title,
        setTitle,
        title_output,
        setTitle_output,
        ref_num,
        setRef_num,
        single_user,
        setSingle_user,
        amount,
        setAmount,
        percent,
        setPercent,
        max_discount_amount,
        setMax_discount_amount,
        min_invoice_amount,
        setMin_invoice_amount,
        expiration_date,
        setExpiration_date,
        is_active,
        setIs_active,
        description,
        setDescription,
        service,
        setService,
        usage_total,
        setUsage_total,
        usage_per_client,
        setUsage_per_client,
        isShowModal,
        isShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetServices,
        handleGetDiscountCouponItemList,
        handleGetDiscountCouponItem,
        handleCreateDiscountCouponItem,
        handleEditDiscountCouponItem,
        handleDeleteDiscountCouponItem,
      }}
    >
      {children}
    </discountCouponAdminContext.Provider>
  );
};

export default DiscountCouponAdminContext;